import React from 'react';
import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconSelfTransfer(props: IconType) {
    const {
        width = '16',
        height = '16',
        fill = '#070c63',
        stroke = '#070c63',
        viewBox = '0 0 16 16',
        title = 'IconSelfTransfer',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            fill={fill}
            stroke={stroke}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <path
                    d="m5.18074656 12.3917526 5.63850684-7.9175258h2.7779961l-1.0726915.96219932c-.0641782.06414662-.1031435.13974799-.1168959.22680412-.0137525.08705613.0114604.1580756.0756385.21305842l.0825147.10996564c.0641782.06414662.1421087.09621993.2337918.09621993.091683 0 .1696136-.03207331.2337917-.09621993l1.7465619-1.58075602h.0068762c.0045842 0 .0068763-.0045819.0068763-.0137457l.1100196-.10996564c.0366732-.02749141.0618861-.05956472.0756385-.09621993.0137525-.03665521.0206287-.07789233.0206287-.12371134 0-.03665521-.0068762-.07560137-.0206287-.11683849-.0137524-.04123711-.0389653-.07560137-.0756385-.10309278l-.1237721-.12371134-1.7740668-1.62199313c-.0641781-.06414662-.1421087-.09621993-.2337917-.09621993-.0916831 0-.1696137.03207331-.2337918.09621993l-.0825147.10996564c-.0641781.06414662-.089391.13974799-.0756385.22680412.0137524.08705613.0527177.1580756.1168958.21305842l1.0451867.94845361h-3.1768173l-5.63850688 7.91752578h-3.72691552v.8797251zm1.3064833-5.51202751.55009823-.75601375-1.85658153-2.52920962h-4.18074656v.87972508h3.72691552zm6.31237724 7.12027491c.091683 0 .1696136-.0320733.2337917-.0962199l1.7465619-1.580756h.0068762c.0045842 0 .0068763-.0045819.0068763-.0137457l.1100196-.1099657c.0366732-.0274914.0618861-.0595647.0756385-.0962199.0137525-.0366552.0206287-.0778923.0206287-.1237114 0-.0366552-.0068762-.0756013-.0206287-.1168384-.0137524-.0412372-.0389653-.0756014-.0756385-.1030928l-.1100196-.1099657h-.0068763c-.0045841 0-.0068762-.0045819-.0068762-.0137457l-1.7740668-1.6219931c-.0641781-.06414662-.1421087-.09621993-.2337917-.09621993-.0916831 0-.1696137.03207331-.2337918.09621993l-.0825147.1099656c-.0641781.0641467-.089391.139748-.0756385.2268042.0137524.0870561.0527177.1580756.1168958.2130584l1.0589391.9621993-2.7367387-.0137457-1.58153238-2.4329897-.53634577.76975945 1.66404715 2.54295535 3.2180747.0137457-1.0589391.9484536c-.0641782.0641466-.1031435.139748-.1168959.2268041-.0137525.0870561.0114604.1580756.0756385.2130584l.0825147.1099657c.0641782.0641466.1421087.0962199.2337918.0962199z"
                    fill={fill}
                    stroke={stroke}
                    strokeWidth="1.173543"
                />
            )}
        />
    );
}

export default IconSelfTransfer;
